import React from 'react';

interface ToastProps {
  message: string | null;
}

export const Toast: React.FC<ToastProps> = ({ message }) => {
  if (!message) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 px-4 py-2 bg-zinc-900 border border-zinc-700/80 text-white text-xs font-mono rounded-full shadow-2xl flex items-center gap-2 animate-bounce-short">
      <span className="w-2 h-2 rounded-full bg-emerald-400"></span>
      <span>{message}</span>
    </div>
  );
};
